var Cart = /** @class */ (function () {
    function Cart(obj, quantity, itemType) {
        this.item = obj;
        this.itemType = itemType;
        this.quantity = quantity;
    }
    return Cart;
}());
export { Cart };
